export const isNumber = (val: any) => !isNaN(parseFloat(val)) && isFinite(val);
